/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Service_LineInputs */

const en_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creative Line`)
};

const es_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línea creativa`)
};

const fr_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligne créative`)
};

const de_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreativer Bereich`)
};

const ja_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイティブの種類`)
};

const zh_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创意服务线`)
};

const ar_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخط الإبداعي`)
};

const id_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lini Kreatif`)
};

const it_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settore Creativo`)
};

const ru_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Направление креатива`)
};

const pt_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha Criativa`)
};

const ko_field_service_line = /** @type {(inputs: Field_Service_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이티브 분야`)
};

/**
* | output |
* | --- |
* | "Creative Line" |
*
* @param {Field_Service_LineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_service_line = /** @type {((inputs?: Field_Service_LineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Service_LineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_service_line(inputs)
	if (locale === "es") return es_field_service_line(inputs)
	if (locale === "fr") return fr_field_service_line(inputs)
	if (locale === "de") return de_field_service_line(inputs)
	if (locale === "ja") return ja_field_service_line(inputs)
	if (locale === "zh") return zh_field_service_line(inputs)
	if (locale === "ar") return ar_field_service_line(inputs)
	if (locale === "id") return id_field_service_line(inputs)
	if (locale === "it") return it_field_service_line(inputs)
	if (locale === "ru") return ru_field_service_line(inputs)
	if (locale === "pt") return pt_field_service_line(inputs)
	return ko_field_service_line(inputs)
});